import { Box, Table, TableBody, TableHead } from '@mui/material';
import React from 'react';

import { HeadingCell, StyledTableRow } from './FaultDefinitions.styles';
import { Button, ButtonVariantProps, ButtonColorProps } from '../../atoms/Button';
import { FaultDefinition } from '../../molecules/FaultDefinition';

import { FaultDefinitaionsProps } from '.';

export const FaultDefinitions: React.FC<FaultDefinitaionsProps> = ({
  faults,
  onChangeChildDefinitions,
  onChangeHeaderDefinition
}) => {
  return (
    <Table>
      <TableHead>
        <StyledTableRow>
          <HeadingCell sx={{ width: '25%' }}>Name</HeadingCell>
          <HeadingCell sx={{ width: '15%' }}>Customer ID</HeadingCell>
          <HeadingCell sx={{ width: '15%' }}>Customer ID 2</HeadingCell>
          <HeadingCell sx={{ width: '15%' }}>Action Types</HeadingCell>
          <HeadingCell sx={{ width: '10%' }} align="center">
            Reported
          </HeadingCell>
          <HeadingCell sx={{ width: '10%' }} align="center">
            Observed
          </HeadingCell>
          <HeadingCell sx={{ width: '10%' }} align="center">
            Active
          </HeadingCell>
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {faults.map((fault, faultIndex) => (
          <>
            <FaultDefinition key={faultIndex} isParentFaultDefinition={true} testDataId={`fault-${faultIndex}`} faultDefinitaionData={fault} onChange={(updatedData) => { onChangeHeaderDefinition(updatedData, faultIndex); }} />
            {fault.childFaults.map((childFault, index) => (
              <FaultDefinition key={index} faultDefinitaionData={childFault} testDataId={`fault-${faultIndex}-code-${index}`} onChange={(updatedData) => {     
                const childFaults = fault.childFaults;
                childFaults[index] = updatedData;
                onChangeChildDefinitions(childFaults, faultIndex);
              }} />
            ))}
            <Box sx={{ paddingTop: 1, paddingBottom: 1 }}>
              <Button 
                variant={ButtonVariantProps.Primary} 
                color={ButtonColorProps.Primary} 
                onClick={() => onChangeChildDefinitions([...fault.childFaults, { 
                  name: '', 
                  customerId: '', 
                  customerId2: '',
                  actionTypes: [],
                  isReported: true,
                  isObserved: true,
                  isActive: true 
                }], faultIndex)} 
                data-testid={`fault-${faultIndex}-add-fault-code`}
              >
                Add fault code
              </Button>
            </Box>
          </>
        ))}
      </TableBody>
    </Table>
  );
};